// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IUserEstimationHistoryResponseSchema {
  /** адрес **/
  address: string;
  /** тип карточки истории **/
  dealType: string;
  /** Id оценки пользователя **/
  estimationId: number;
  /** поле которое говорит растет цена или нет **/
  priceDiff: EPriceDiff;
  /** Заголовок для информации о истории оценки **/
  title: string;
  /** url адрес на отчёт **/
  url: string;
}
export enum EPriceDiff {
  /** Оценка снизилась **/
  'Decrease' = 'decrease',
  /** Оценка увеличилась **/
  'Increase' = 'increase',
  /** Оценка не изменилась **/
  'NotChanged' = 'notChanged',
}
